/**
 * SPM 埋点能力入口。编码表请直接从 ./codes/{page} 导入（便于 tree-shaking），
 * 会话与注入能力从本文件导入。
 */
export {
  attachSpmTracking,
  captureSpmClickRefer,
  getPageReferSpm,
  isSpmClickEvent,
  refreshPageReferSpm,
  withSpmCnt,
} from './spm-session';
export { SpmScopeProvider, useSpmModuleCode, useSpmPosition, useSpmScope } from './spm-scope';
export { DataSpmProvider, useDataSpmEnabled, useSpmDomAttr, useSpmTerminalKind } from './spm-dom';
// 检视器经门闸懒加载：barrel 只能导出门闸与类型，静态重导出 loader/插件
// 会把它们的代码拉回主包，开关关闭时也会随包下发（见 spm-inspector-gate）。
export { SpmInspectorGate } from './spm-inspector-gate';
export type { SpmInspectorHandle } from './spm-inspector';
export { getSpmPageCodes, SPM_PAGE_CODES } from './spm-pages';
export type { SpmPageId } from './spm-pages';
export { resolveSpmTerminalKind } from './terminal';
export type { SpmTerminalKind } from './terminal';
export type { SpmModuleCodes, SpmPageCodes } from './types';
